import Component from './setting_user.vue'
export default Component
